import React, { useState, useEffect, useCallback } from "react";
import "../../css/manage_waba.css";
import { apiCall } from "../../services/authServieces";
import ShowSnackBar from "../../components/snackBar";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Search from "../../Assets/images/search.png";
import Papa from "papaparse";
import excelIcon from "../../Assets/images/excel.png";

const DeliveryReport = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [snackBar, setSnackBar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const location = useLocation();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { selectedRow } = location.state || {};
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("whatsapp");

  const columns = [
    { id: "created_by", label: "Dealer Code", minWidth: 100 },
    { id: "user_name", label: "Name", minWidth: 100 },
    { id: "company_name", label: "Company", minWidth: 100 },
    { id: "count", label: "Total", minWidth: 100 },
    { id: "delivered", label: "Delivered", minWidth: 100 },
    { id: "failed", label: "Failed", minWidth: 100 },
  ];

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCloseSnackBar = (event, reason) => {
    setSnackBar((prevState) => ({ ...prevState, open: false }));
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let endpoint = `api/reports/get-dashboard-dealer?page=${page + 1}&limit=${rowsPerPage}`;
      if (debouncedSearchTerm) {
        endpoint = `${endpoint}&search=${debouncedSearchTerm}`;
      }

      const response = await apiCall({ method: "GET", endpoint: endpoint });

      if (response.success) {
        setRows(response.data || []);
        setTotal(response.total || 0);
      } else {
        setSnackBar({
          open: true,
          severity: "error",
          message: "Failed to fetch data",
        });
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("API Error:", error);
      setSnackBar({
        open: true,
        severity: "error",
        message: "Error occurred while fetching data",
      });
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, debouncedSearchTerm]);


  const fetchDealerSms = useCallback(async () => {
    setLoading(true);
    try {
      let endpoint = `api/reports/get-dashboard-sms-dealer?page=${page+1}&limit=${rowsPerPage}`;
      if (debouncedSearchTerm) {
        endpoint = `${endpoint}&search=${debouncedSearchTerm}`;
      }

      const response = await apiCall({ method: "GET", endpoint: endpoint });

      if (response.success) {
        setRows(response.data || []);
        setTotal(response.total || 0);
      } else {
        setSnackBar({
          open: true,
          severity: "error",
          message: "Failed to fetch data",
        });
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("API Error:", error);
      setSnackBar({
        open: true,
        severity: "error",
        message: "Error occurred while fetching data",
      });
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, debouncedSearchTerm]);

  useEffect(() => {
    if (selectedTab === "whatsapp") {
      fetchData();
    } else if (selectedTab === "sms") {
      fetchDealerSms();
    }
  }, [page, rowsPerPage, debouncedSearchTerm, selectedTab]);


  const handleExportDealer = () => {

    if (selectedTab == "whatsapp") {
      handleExport()
    } else {
      handleExportSmsDealers()
    }
  }

  const handleExport = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user-cred"));
      const token = user?.token;
      const baseURL = process.env.REACT_APP_API_URL;

      let endpoint = `${baseURL}/api/reports/export-dashboard-dealer?page=${page}&limit=${rowsPerPage}`;
      if (debouncedSearchTerm) {
        endpoint += `&search=${debouncedSearchTerm}`;
      }

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const contentType = response.headers.get("content-type");
      if (!response.ok || !contentType.includes("text/csv")) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to export report");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "dashboard_dealer_report.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Export Error:", error);
      setSnackBar({
        open: true,
        severity: "error",
        message: "Failed to export report",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleExportSmsDealers = async () => {
    setLoading(true);
    try {

      const user = JSON.parse(localStorage.getItem("user-cred"));
      const token = user?.token;
      const baseURL = process.env.REACT_APP_API_URL;

      let endpoint = `${baseURL}/api/reports/download-sms-dealers-report`;

      const params = new URLSearchParams();
      if (debouncedSearchTerm) params.append("search", debouncedSearchTerm);

      endpoint = `${endpoint}?${params.toString()}`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to export SMS Dealers Report");

      const blob = await response.blob();

      let filename = "SMS_Dealers_Report.csv";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = decodeURIComponent(match[1]);
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSnackBar({
        open: true,
        severity: "success",
        message: "SMS Dealers Report downloaded successfully",
      });
    } catch (error) {
      console.error(error);
      setSnackBar({
        open: true,
        severity: "error",
        message: "Failed to download SMS Dealers Report",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); // Reset to first page when searching
  };

  const handleRowClick = (row) => {
    const userId = row?.created_by;
    navigate(`/admin/delivery-report/${userId}`, { state: { rowData: row, currentTab: selectedTab } });
  };
  const getCurrentDateInIST = () => {
    const now = new Date();

    // Convert to Indian Standard Time (IST)
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'long', // 'short' for abbreviated month names
      day: 'numeric',
    };

    return new Intl.DateTimeFormat('en-IN', options).format(now);
  };

  return (
    <>
      <div className="Template_id_contian">
        <h4 className="Head_title AdminSearchContain DailyReport">
          <div className="TodayDeliveryRepot">
            {getCurrentDateInIST()}
          </div>

          Live Report

          <div className="Session_report_SearchContain select_dropdown select_dropdown_n ">
            <select value={selectedTab} onChange={(e) => setSelectedTab(e.target.value)}>
              <option value="whatsapp">WhatsApp</option>
              <option value="sms">SMS</option>
            </select>
            <div className="search_box_group_n new_mr_55">
              <input
                placeholder="Search"
                type="text"
                className="smart_search_n"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <button type="button" className="ExcelIconContain add_btn7 new_mr_ed1" onClick={handleExportDealer}>
                <img src={excelIcon} alt="excelIcon" className="ExcelIcon" />
              </button>
            </div>

          </div>
        </h4>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" className="Table ColorBlueTable DailyReportTable">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length > 0 ? (
                  rows.map((row, index) => (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={`${row.created_by}-${index}`}
                      onClick={() => handleRowClick(row)}
                      style={{ cursor: "pointer" }}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id}>
                            {value !== undefined && value !== null ? value : '-'}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
                ) : (
                  !loading && (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
      <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        onClose={handleCloseSnackBar}
      />
    </>
  );

};
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default DeliveryReport;